import axios from 'axios'
import qs from 'qs'

// axios默认可修改Cookie
axios.defaults.withCredentials = true
//根据域名，确定接口地址
var apiaddress;
if (window.location.hostname == 'xueyuan.aiyaopai.com' || window.location.hostname == 'xueyuan.aiyaopai.com') {
  apiaddress = "https://apiv2.aiyaopai.com";
} else {
  apiaddress = "https://apiv2.dev.aiyaopai.com";
  // apiaddress = "https://apiv2.aiyaopai.com";
}


axios.interceptors.request.use(function (config) {
  if (window.localStorage.getItem("Token")) {
      config.headers.Authorization = 'Bearer ' + window.localStorage.getItem("Token");    //将token放到请求头发送给服务器
      return config;
  }else{
      return config;
  }
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
// 接口定义
const api = {
  // 课程
  course: {
    paidCourseUser:'TutorialPaidHistory.BuyerSearch',//查找购买课程用户列表
    addCoursePaidHistory: 'TutorialPaidHistory.Insert', //添加课程购买历史
    getCourse: 'Tutorial.Get', //获取单个课程信息 接口：获取单个课程
    AliUrl:'Tutorial.AliUrl',//获取单个课程播放 URL
    searchCourseEvaluateList: 'TutorialReview.Search', // 查找课程评价列表
    getCourseList: 'Tutorial.Search', //相关课程推荐的 接口：查找课程列表
    storeCourse: 'Tutorial.Favorite', //点击收藏 收藏功能 接口：收藏课程
    UnstoreCourse: 'Tutorial.Unfavorite', //点击收藏 取消收藏功能 接口：取消收藏课程
    getStoreCourseList: 'Tutorial.FavoritedSearch', //接口：查找收藏课程列表
    getPaidCourseList: 'TutorialPaidHistory.Search', //接口：查找购买历史列表
    courseReview: 'TutorialReview.Insert', //接口：添加课程评价
    checkCourseReview: 'TutorialReview.Check', //接口：判断是否可评价
    courseAddOnReview: 'TutorialReviewAddOn.Insert', //课程追评，接口：追加课程评价
    getWeChatPromotionCount: 'Tutorial.Get',//******后端生成需要邀请人数 */
    getTutorialPromotionCard: 'Tutorial.GenerateWeChatPromotionCard', //后端渲染生成邀请卡
    getCourseCoupon: 'TutorialCoupon.SearchByTutorial', //查找课程可用优惠卷列表
    coursePayForpalance: 'TutorialOrder.AssetBalancePay', //帐户余额购买课程
    coursePayForpalanceAddCoin: 'TutorialOrder.AssetBalancePointsPay',//******邀币+余额购买课程 */
    refreshCourseOrder: 'TutorialOrder.Refresh', //刷新订单支付状态
    getWechatPay: 'TutorialOrder.WeChatWebPaymentToken', //获取微信 Web 支付令牌
    getWechatPayAddCoin: 'TutorialOrder.WeChatWebPaymentWithPointsToken', //******获取微信+邀币Web支付令牌 */
    getCourseReview: 'TutorialReview.Get', //获取单个课程评价
    getCourseCouponList: 'TutorialCoupon.Search', //查找课程优惠券列表
    getCellCourseOrder: 'TutorialOrder.Get', //获取单个课程订单
    closeCourseOrder: 'TutorialOrder.Close', //关闭未支付订单
    LikeCourse: 'Tutorial.Like', //点赞课程
    UnlikeCourse: 'Tutorial.Unlike', //取消课程点赞
    getCourseType: 'TutorialTagBanner.Search',//******获取课程类别列表 */
    getCourseTypeThis: 'TutorialTagBanner.Get',//******获取课程类别详细banner */
    getCourseTypeCon: 'Tutorial.Search'//******获取课程类别下课程列表 */
  },
  // 文章
  article: {
    ArticleList: 'Article.Search', //接口：查找文章列表
    getArticle: 'Article.Get', //接口：获取单个文章
    getArticleContentList: 'ArticleContent.Search', //获取文章的内容列表
    getArticleTipList: 'ArticleTip.Search', //接口：查找文章打赏列表
    getArticleCommentList: 'ArticleComment.Search', //查找文章评论列表
    getCollectArticleList: 'Article.FavoritedSearch', //查找收藏文章列表
    articleLike: 'Article.Like', //文章点赞
    articleUnlike: 'Article.Unlike', //取消文章点赞
    articleCollect: 'Article.Favorite', //文章收藏
    articleUncollect: 'Article.Unfavorite', //取消文章收藏
    articleCommentLike: 'ArticleComment.Like', //接口：点赞文章评论
    articleCommentUnlike: 'ArticleComment.Unlike', //接口：取消点赞文章评论
    articleContentLike: 'ArticleContent.Like', //点赞文章内容
    articleContentUnlike: 'ArticleContent.UnLike', //取消点赞文章内容
    articleTipBalance: 'ArticleTip.AssetBalancePay', //文章打赏 余额打赏
    refreshArticleTip: 'ArticleTip.Refresh', //刷新打赏支付状态
    articleTipBywechatToken: 'ArticleTip.WeChatWebPaymentToken', //获取微信 Web 支付令牌
    articleComment: 'ArticleComment.Insert', //添加文章评论
    getNoticeList: 'Notice.Search', //查找通知列表
    readNotice: 'Notice.Read', // 标记已读
    readAllNotice: 'Notice.ReadAll', //标记全部已读
    getLikeList: 'Article.LikedSearch', // 查找点赞文章列表
    getArticleCommentAtList: 'ArticleCommentCall.Search', //查找文章评论艾特列表
    getArticleAtList: 'ArticleCall.Search', //查找文章艾特列表
    getCellArticleTip: 'ArticleTip.Get', //获取单个文章打赏
    getMessageLike: 'MessageLike.Search', // 喜欢-查找列表
    getMessageComment: 'MessageComment.Search', // 消息-评论-查找列表
    MessageCommentReadAll: 'MessageComment.ReadAll', // 消息-评论-查找列表 将所有未读消息标记为已读
    getMessageCall: 'MessageCall.Search', // @我的-查找列表
    MessageCallReadAll: 'MessageCall.ReadAll', // @我的-查找列表 将所有未读消息标记为已读
    articleAddView: 'Article.View', //增加文章浏览量
    deleteArticleComment:'ArticleComment.Delete'//******删除文章评论
  },
  //圈子 动态
  circle: {
    ActivityVote:'ActivityVote.Insert',//活动作品投票
    TrendVoteRank:'TrendVoteRank.Get',//获取动态投票排名
    SearchRecommendId: 'Trend.SearchRecommendId', //推荐动态id
    SearchRecommendDetail: 'Trend.Search', //推荐或关注动态详情列表，不带分页
    SearchTrend:'Trend.GlobalSearch',//动态搜索，带分页
    getRecommenViewTop: 'Trend.RecommendSearch',//推荐页置顶的动态列表
    getCellCircle: 'Trend.Get', //获取单个动态
    TrendSearchUser:'Trend.SearchUser',//查找动态列表 我发布的
    TrendReview:'TrendReview.Insert',//添加动态评价
    GetTrendReview:'TrendReview.Get',//获取单个动态评价
    LikeTrendList: 'Trend.LikedSearch', //查找点赞动态列表
    LikeTrend: 'Trend.Like', //点赞动态
    UnlikeTrend: 'Trend.UnLike', //取消点赞动态
    getUserTrendList: 'Trend.SearchUser', //查找动态列表-我发布的 UserId不传的话查询当前登录用户发布的动态列表
    getTrendComment: 'TrendComment.Search', //查找动态评论列表
    likeTrendComment: 'TrendComment.Like', //点赞动态评论
    unlikeTrendComment: 'TrendComment.UnLike', //取消点赞动态评论
    addTrendComment: 'TrendComment.Insert', //添加动态评论
    getCircleLikeList: 'Trend.LikedUserSearch', //查找点赞动态用户列表
    getFollowIdList: 'Trend.SearchFollowId', //查找动态列表-关注
    InsertTrend: 'Trend.Insert', //发布动态
    InsertTrendTag: 'TrendTag.Insert', //添加圈子
    UpdateTrendTag:'TrendTag.Update',//修改圈子
    JoinTrendTag: 'UserFollowTrendTag.Search', //用户关注的圈子列表
    SearchTrendTag: 'TrendTag.Search', //查找圈子列表 
    MineTrend: 'TrendTag.Mine', //查找用户创建圈子列表 
    UserFollowTrend: 'UserFollowTrendTag.Search', //查找用户关注圈子列表 
    getTrendList: 'Trend.SearchTag', //查找动态列表
    FollowTrendTag: 'TrendTag.Follow', //关注圈子
    UnfollowTrendTag: 'TrendTag.UnFollow', //取关圈子
    GetTrendTag: 'TrendTag.Get', //获取单个圈子
    TrendTagJoinUser: 'TrendTagFollowUser.Search', //参与圈子的用户列表
    GetCollectTrendList: 'Trend.FavoritedSearch', //获取收藏动态列表
    GenerateCombinedCard: 'Trend.GenerateCombinedCard', //动态生成分享图
    CollectTrend: 'Trend.Favorite', //收藏动态
    UnCollectTrend: 'Trend.UnFavorite', //取消收藏动态
    deleteTrendComment:'TrendComment.Delete', //******删除动态评论
    deleteTrend:'Trend.Delete'//******删除动态
  },
  location:{
    TrendLocation:'TrendLocation.Search',//查找动态位置列表
    SeriesList:'Series.Search',//获取套系列表
    PhotographerCategory:'PhotographerCategory.Get',//获取摄影师类目
    getSeriesDetail:'Series.Get',//获取单个套系
    TrendBanner:'Trend.Banner',//获取最新动态 Banner图
    SearchLocation:'Trend.SearchLocation',//查找动态列表-打卡地
    getTrendLocation:'TrendLocation.Get',//获取单个动态位置
    HomeHotCityGet:'Advertisement.HomeHotCityGet',// 获取首页热门城市 
    TrendLocationJoinUser:'TrendLocationJoinUser.Search',//参与动态位置的用户列表
    SeriresOrder:'SeriesOrder.Place',//用户下单 用户令牌
    SeriesFavorite:'Series.Favorite',//收藏套系
    SeriesUnFavorite:'Series.UnFavorite',//取消收藏套系
    TrendLocationStatistics:'TrendLocation.Statistics',//打卡地信息统计
    TrendLocationReview:'TrendLocationReview.Insert',//添加动态位置评价
    LocationCategory:'LocationCategory.GetPhotographer',//获取摄影师类目
  },
  public: {
    AdvertisementNew:'Advertisement.AppHomeSlideNewGet',//2020新窄轮播图(获取APP首页幻灯片（新）)
    BannerImage: 'Advertisement.WebHomeSlideGet', //获取 Web 首页幻灯片
    miniBannerImage:'Advertisement.MiniProgramHomeSlideGet',//获取小程序首页轮播
    getHomeArticleTag: 'Advertisement.HomeArticleTagGet', //获取首页文章标签
    getHomeArticleUser: 'Advertisement.HomeArticleUserGet', //获取首页文章作者
    getHomeCourseUser: 'Advertisement.HomeTutorialUserGet', //获取首页课程作者,人气讲师
  },
  //用户
  user: {
    changePhoneNo: 'User.ChangePhoneNo', //手机号换绑
    changePhoneNoVerify: 'User.ChangePhoneNoVerify', //手机号换绑验证,需用户令牌
    bindPhoneNo: 'User.BindPhoneNo', //手机号绑定
    BindPhoneNoVerify: 'User.BindPhoneNoVerify', //手机号绑定验证
    checkPhoneNo: 'User.CheckPhoneNo', ////检验手机号是否已经注册占用过了 接口：检查手机号可用性,返回结果为true为可用即未注册，false为不可用，已经注册
    signInWithPhoneNo: 'User.SignInWithPhoneNo', //已注册用户用手机号验证码登录 接口：验证码登录请求
    signInWithPhoneNoVerify: 'User.SignInWithPhoneNoVerify', //已注册用户用手机号验证码登录验证 接口：验证码登录验证
    RegisterWithPhoneNo: 'User.RegisterWithPhoneNo', //注册时获取注册验证码 接口：手机号注册
    RegisterWithPhoneNoVerify: 'User.RegisterWithPhoneNoVerify', //注册验证 接口：手机号注册验证
    loginPassword: 'User.SignIn', //登录 接口：密码登录
    logweChat: 'User.SignInWithWeChat', //微信登录 接口：微信登录
    loginwechat: 'User.SignInWithWeChat', //微信登录 接口：微信登录
    forgetPassWord: 'User.ResetPasswordWithPhoneNo', //登录时忘记密码 接口：手机号重置密码
    forgetPassWordVerify: 'User.ResetPasswordWithPhoneNoVerify', //登录时忘记密码在获取了找回密码的验证码后，表单验证 接口：手机号重置密码验证
    getCurrentUser: 'User.CurrentUser', //登录后获取当前用户信息 接口：获取当前用户
    bindingWechat: 'User.BindWeChat', //微信绑定，需要在用户登录成功之后 接口：微信绑定
    UnbindingWechat: 'User.UnBindWeChat', //微信解绑 接口：微信解绑
    userFollow: 'User.Follow', //点击关注按钮，关注用户（需在登录的状态下） 接口：关注用户
    UnuserFollow: 'User.Unfollow', //点击关注按钮，取消关注用户（需在登录的状态下）接口：取消关注用户
    userGet: 'User.Get', //接口：获取单个用户
    updateInfoAvatarNikename: 'User.UpdateInfo', //修改个人信息 昵称及头像 接口：修改个人信息
    updateInfo: 'User.UpdateInfo', //修改个人信息 接口：修改个人信息
    CheckNickname: 'User.CheckNickname', //检验昵称可用性 接口：检查昵称可用性
    SignOut: 'User.SignOut', //退出登录 接口：退出登录
    searchUserList: 'User.Search', //查找用户列表
    getFollowerList: 'User.FollowerSearch', //查找粉丝用户列表
    getFollowingList: 'User.FollowingSearch', //查找关注用户列表
    addFeedback: 'Feedback.Insert', //添加意见反馈
    ChangeWithdrawAccount: 'UserFunds.ChangeBeneficiaryWithPhoneNo', //修改提现账户
    ChangeWithdrawAccountVerify: 'UserFunds.ChangeBeneficiaryWithPhoneNoVerify', //手机号修改提现账户验证
    getUserFundsList: 'UserFunds.HistorySearch', //查找资金历史列表
    getUserWithdrawList: 'UserWithdraw.Search', //查找提现列表
    getUserLapFundsList: 'UserIapFunds.HistorySearch', //查找内购资金(苹果)历史列表
    userWithdraw: 'UserWithdraw.Apply', //申请提现
    getCellLapFudsDetail: 'UserIapFunds.HistoryGet', //获取单个当前用户内购资金历史
    getCellWithdrawDetail: 'UserWithdraw.Get', //获取单个提现
    checkPhoneNoCode: 'PhoneNoCode.Verify', //手机号验证手机验证码,该接口提供手机验证码统一验证功能, 适用于某些需要单独验证验证码的特定流程.
    vipExchange:'User.VipExchange',//兑换月度会员
  },
  // 通用
  common: {
    getUptoken: 'Storage.Token', //  七牛上传图片获取上传令牌 接口：存储 获取上传令牌
    refreshToken: 'User.RefreshToken', //刷新令牌  接口：刷新令牌
  },
  //******邀币系统 */
  UserPoints: {
    getUserPoints: 'UserPoints.Statistics'
    ,getUserPointsHistory: 'UserPointsHistory.All'
    ,getPointsMission: 'Mission.All'
    ,receivePoints: 'Mission.ReceivePoints'
  }
}
//发布动态
const InsertTrend = (content, contentType, cover, description, calls, tags) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.InsertTrend,
      content: content,
      contentType: contentType,
      cover: cover,
      description: description,
      calls: calls,
      tags: tags
    }
    axios.post(apiaddress, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//动态生成分享图
const GenerateCombinedCard = (Id, QrUrl) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.GenerateCombinedCard,
      Id: Id,
      QrUrl: QrUrl
    }
    axios.post(apiaddress, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取收藏动态列表
const GetCollectTrendList = (pageIndex, pageSize, fromUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.GetCollectTrendList,
      fields: "Id,Content,CreatedAt,Liked,Favorited,LikeCount,ContentType,Cover,Description,HomeRecommended,LikeCount,ViewCount,CommentCount,User.Avatar,User.Id,User.Nickname,User.Followed,CallUsers.Nickname,CallUsers.Id,Tags.Id,Tags.Name",
      pageIndex: pageIndex,
      pageSize: pageSize,
      fromUserId: fromUserId,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//收藏动态
const CollectTrend = (trendId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.CollectTrend,
      trendId: trendId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//取消收藏动态
const UnCollectTrend = (trendId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.UnCollectTrend,
      trendId: trendId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//查找动态列表-圈子
const getTrendList = (pageIndex, pageSize, tagId, orderByPopularity, orderByCreatedAt) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.getTrendList,
      fields: "Id,Content,ContentType,Cover,CommentCount,LikeCount,Liked,Description,User.Avatar,User.Nickname,User.Id,Tags.Id,Tags.Name,Tags.Banner,Tags.Logo,ReviewsCount,AverageRating",
      pageIndex: pageIndex,
      pageSize: pageSize,
      tagId: tagId,
      orderByPopularity: orderByPopularity,
      orderByCreatedAt: orderByCreatedAt
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//关注圈子
const FollowTrendTag = (tagId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.FollowTrendTag,
      tagId: tagId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//取消关注圈子
const UnfollowTrendTag = (tagId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.UnfollowTrendTag,
      tagId: tagId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取单个圈子
const GetTrendTag = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.GetTrendTag,
      id: id,
      fields: 'Id,Name,Banner,Logo,Description,FollowCount,Creator.Avatar,Creator.PersonalStatus,Creator.Nickname,Creator.Id,TrendCount,Followed'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//参与圈子的用户列表
const TrendTagJoinUser = (pageIndex, pageSize, Id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.TrendTagJoinUser,
      fields: "Avatar,Nickname,Id,Followed,MutualFollowed",
      pageIndex: pageIndex,
      pageSize: pageSize,
      Id: Id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//用户参与的圈子列表
const JoinTrendTag = (pageIndex, pageSize, Id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.JoinTrendTag,
      fields: "Id,Name,TrendCount,Logo,Banner,Creator.Avatar",
      pageIndex: pageIndex,
      pageSize: pageSize,
      Id: Id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找圈子列表
const SearchTrendTag = (pageIndex, pageSize, key, recommended, orderByPopularity, MinTrendCount) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.SearchTrendTag,
      fields: "Id,Name,TrendCount,Banner,Logo,FollowCount,ViewCount,Followed,Creator.Avatar,Description",
      MinTrendCount: MinTrendCount,
      pageIndex: pageIndex,
      pageSize: pageSize,
      key: key,
      recommended: recommended,
      orderByPopularity: orderByPopularity
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找创建的圈子列表
const MineTrend = (pageIndex, pageSize, Ids, key) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.MineTrend,
      fields: "Id,Name,Banner,Logo,Description,Recommended,TrendCount,FollowCount,ViewCount,Popularity,CreatedAt,UpdatedAt,Followed",
      pageIndex: pageIndex,
      pageSize: pageSize,
      Ids: Ids,
      key: key
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找关注圈子列表
const UserFollowTrend = (pageIndex, pageSize, Id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.UserFollowTrend,
      fields: "Id,Name,Banner,Logo,Description,Recommended,TrendCount,FollowCount,ViewCount,Popularity,CreatedAt,UpdatedAt,Followed,Creator.Avatar",
      pageIndex: pageIndex,
      pageSize: pageSize,
      Id: Id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//添加圈子
const InsertTrendTag = (name, banner, logo, description) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.InsertTrendTag,
      name: name,
      banner: banner,
      logo: logo,
      description: description
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//修改圈子
const UpdateTrendTag = (id, banner, logo, description) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.UpdateTrendTag,
      id: id,
      banner: banner,
      logo: logo,
      description: description
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找点赞动态列表
const LikeTrendList = (pageIndex, pageSize, ids, fromUserId, toUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.LikeTrendList,
      fields: 'Id,Calls,Liked,Favorited,Content,ContentType,Cover,Description,UserId,FavoriteCount,LikeCount,ViewCount,Popularity,ShareCount,CommentCount,HomeRecommended,CreatedAt,UpdatedAt,Tags.Id,Tags.Name,LikedUser.Nickname,LikedUser.Id,LikedUser.Avatar,User.Avatar,User.Nickname',
      pageIndex: pageIndex,
      pageSize: pageSize,
      ids: ids,
      fromUserId: fromUserId,
      toUserId: toUserId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//点赞动态
const LikeTrend = (trendId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.LikeTrend,
      trendId: trendId,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//取消点赞动态
const UnlikeTrend = (trendId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.UnlikeTrend,
      trendId: trendId,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//圈子 推荐动态id
/**
 * 
 */
const SearchRecommendId = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.SearchRecommendId,
      orderByCreatedAt: 'Descending',
      // orderByPopularity:'Descending',
      // orderByHomeRecommended:'Descending'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//活动作品投票
const ActivityVote = (trendId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.ActivityVote,
      trendId: trendId,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//活动投票排名
const TrendVoteRank = (trendId,activityId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.TrendVoteRank,
      trendId:trendId,
      activityId:activityId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//动态 推荐页置顶动态
/**
 * 
 */
const getRecommenViewTop = (topNum) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.getRecommenViewTop,
      fields: 'Id,Content,CreatedAt,Liked,LikeCount,ContentType,Cover,Description,HomeRecommended,LikeCount,ViewCount,CommentCount,User.Avatar,User.Id,User.Nickname,User.Role,User.PersonalStatus,User.Followed,CallUsers.Nickname,CallUsers.Id,Tags.Id,Tags.Name,Favorited',
      count:topNum
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//动态 推荐或关注动态详情列表
/**
 * contentType  动态内容类型, Photo - 照片，Video- 视频，Vlog- Vlog
 * featured 	是否精选
 */
const SearchRecommendDetail = (ids,keyword,contentType,featured,isVideo) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.SearchRecommendDetail,
      fields: 'Id,Content,CreatedAt,Liked,LikeCount,ContentType,Cover,Description,HomeRecommended,LikeCount,ViewCount,CommentCount,User.Avatar,User.Id,User.Nickname,User.Role,User.PersonalStatus,User.Followed,CallUsers.Nickname,CallUsers.Id,Tags.Id,Tags.Name,Tags.Banner,Tags.Logo,Favorited,Series.Id,Series.Name,Series.Price,Series.Cover,Location.Id,Location.Name,Location.Logo,Location.Banner,Location.CityName,Location.Name,TrendReview.Rating,Ratings,ReviewsCount,Reviewed,AverageRating',
      ids: ids,
      keyword:keyword,
      contentType:contentType,
      featured:featured,
      isVideo:isVideo
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//动态 推荐或关注动态详情列表
/**
 * contentType  动态内容类型, Photo - 照片，Video- 视频，Vlog- Vlog
 * featured 	是否精选
 */
const SearchTrend = (pageIndex,pageSize,keyword,contentType,featured,isVideo) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.SearchTrend,
      fields: 'Id,Calls,Content,ContentType,Description,Cover,UserId,LikeCount,Liked,User.Avatar,User.Nickname,Location.Address,Location.CityName,Location.Name,Series.Cover,Series.Name,Series.Id,tags.Id,tags.Name,Favorited',
      pageIndex:pageIndex,
      pageSize:pageSize,
      keyword:keyword,
      contentType:contentType,
      featured:featured,
      isVideo:isVideo
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//动态 点赞动态评论
/**
 * 
 */
const likeTrendComment = (commentId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.likeTrendComment,
      commentId: commentId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//动态 发布动态评论
/**
 * 
 */
const addTrendComment = (trendId, content) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.addTrendComment,
      trendId: trendId,
      content: content
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//动态 取消点赞动态评论
/**
 * 
 */
const unlikeTrendComment = (commentId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.unlikeTrendComment,
      commentId: commentId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 查找动态列表-我发布的
/**
 * 
 */
const getUserTrendList = (pageIndex, pageSize, ids, userId, createAtBegin, createAtEnd) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.getUserTrendList,
      fields: 'Id,Calls,Content,ContentType,Cover,Description,HomeRecommended,UserId,CommentCount,FavoriteCount,LikeCount,Popularity,ShareCount,ViewCount,CreatedAt,UpdatedAt',
      pageIndex: pageIndex,
      pageSize: pageSize,
      ids: ids,
      userId: userId,
      createAtBegin: createAtBegin,
      createAtEnd: createAtEnd
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//动态 查找动态评论
/**
 * 
 */
const getTrendComment = (pageIndex, pageSize, trendId, orderByLikeCount, orderByCreatedAt) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.getTrendComment,
      fields: 'Id,TrendId,Calls,Content,LikeCount,Liked,CreatedAt,User.Avatar,User.Id,User.Nickname,User.Role,User.PersonalStatus,Account.PhotographerSelected,Account.PhotographerVerified',
      pageIndex: pageIndex,
      pageSize: pageSize,
      trendId: trendId,
      orderByLikeCount: orderByLikeCount,
      orderByCreatedAt: orderByCreatedAt
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//圈子 查询关注页面动态Id列表
/**
 * 
 */
const getFollowIdList = (top) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.getFollowIdList,
      top: top
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//圈子 查询点赞动态列表
/**
 * 
 */
const getCircleLikeList = (pageIndex, pageSize, trendId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.getCircleLikeList,
      fields: 'Id,Avatar,Nickname,Followed,MutualFollowed,PersonalStatus,CreatedAt',
      pageIndex: pageIndex,
      pageSize: pageSize,
      trendId: trendId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//圈子 获取单个动态
/**
 * 
 */
const getCellCircle = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.getCellCircle,
      fields: 'Id,Content,CreatedAt,AverageRating,Ratings,TrendReview.Rating,ReviewsCount,Reviewed,ContentType,Cover,Description,HomeRecommended,Liked,LikeCount,ViewCount,CommentCount,User.Avatar,User.Id,User.Nickname,User.Followed,User.Role,User.PersonalStatus,CallUsers.Nickname,CallUsers.Id,tags.Id,tags.Name,Favorited,Tags.Logo,Tags.Name,Tags.Id,Location.CityName,Location.Name,Series.Cover,Series.Name,Series.Id,Activity.Id,Activity.Name,Activity.Description,ActivityVoteCount,ActivityVoted,PicturesCount',
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//查找动态列表 
/**
 * 
 */
const TrendSearchUser = (pageIndex,pageSize,userId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.TrendSearchUser,
      fields: 'Id,Content,CreatedAt,Liked,LikeCount,ContentType,Cover,Description,HomeRecommended,LikeCount,ViewCount,CommentCount,User.Avatar,User.Id,User.Nickname,User.Role,User.PersonalStatus,CallUsers.Nickname,CallUsers.Id,Tags.Id,Tags.Name,Tags.Banner,Tags.Logo,Favorited,Series.Id,Series.Name,Series.Price,Series.Cover,Location.Id,Location.Name,Location.Logo,Location.Banner,Location.CityName,TrendReview.Rating,Ratings,ReviewsCount,Reviewed,AverageRating',
      pageIndex:pageIndex,
      pageSize:pageSize,
      userId:userId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//添加动态评价
/**
 * 
 */
const TrendReview = (trendId,rating) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.TrendReview,
      trendId: trendId,
      rating:rating
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取单个动态位置评价
/**
 * 
 */
const GetTrendReview = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.GetTrendReview,
      fields:'Id,Rating',
      id: id,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//******删除动态deleteTrend */
const deleteTrend = (id) =>{
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.deleteTrend,
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//******删除动态评论 */
const deleteTrendComment = (id) =>{
  return new Promise((resolve, reject) => {
    let data = {
      api: api.circle.deleteTrendComment,
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//******删除文章评论 */
const deleteArticleComment = (id) =>{
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.deleteArticleComment,
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//添加文章评论
/**
 * 
 * @param {*} articleId 文章 Id
 * @param {*} content 评论内容
 * @param {*} articleContentId 引用的文章内容 Id
 */
const articleComment = (articleId, content, articleContentId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleComment,
      articleId: articleId,
      content: content,
      articleContentId: articleContentId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//刷新打赏支付状态
/**
 * 
 * @param {id} 打赏id
 */
const refreshArticleTip = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.refreshArticleTip,
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取微信 Web 支付令牌
const articleTipBywechatToken = (openId, articleId, amount, description) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleTipBywechatToken,
      openId: openId,
      articleId: articleId,
      amount: amount,
      description: description
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

/**
 * articleId 文章 Id required
 * amount 打赏金额 (0.99-9999999) required
 *  description 备注
 */
//文章打赏 余额打赏
const articleTipBalance = (articleId, amount, description) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleTipBalance,
      articleId: articleId,
      amount: amount,
      description: description
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//点赞文章内容 ,给文章的内容点赞，现在是文章的图片内容
const articleContentLike = (articleContentId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleContentLike,
      ContentId: articleContentId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//增加文章浏览量
const articleAddView = (articleId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleAddView,
      articleId: articleId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//取消点赞文章内容 ,给文章的内容点赞，现在是文章的图片内容
const articleContentUnlike = (articleContentId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleContentUnlike,
      ContentId: articleContentId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取单个文章打赏
const getCellArticleTip = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getCellArticleTip,
      id: id,
      fields: 'PaymentId,PaymentChannel,CreatedAt,Title,Amount,Buyer.Nickname'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//文章评论点赞 接口：点赞文章评论
const articleCommentLike = (commentId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleCommentLike,
      commentId: commentId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//取消文章评论点赞 接口：取消点赞文章评论
const articleCommentUnlike = (commentId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleCommentUnlike,
      commentId: commentId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//文章点赞
const articleLike = (articleId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleLike,
      articleId: articleId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//取消文章点赞
const articleUnlike = (articleId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleUnlike,
      articleId: articleId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//文章收藏
const articleCollect = (articleId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleCollect,
      articleId: articleId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//取消文章收藏
const articleUncollect = (articleId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.articleUncollect,
      articleId: articleId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//查找收藏文章列表
const getCollectArticleList = (pageIndex, pageSize, fromUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getCollectArticleList,
      fields: 'Id,Title,Cover,CommentsCount,ViewsCount,CreatedAt,User.Avatar,User.Nickname,User.Id',
      pageIndex: pageIndex,
      pageSize: pageSize,
      fromUserId: fromUserId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//******后端生成需要邀请人数 */
const getWeChatPromotionCount = (tutorialId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getWeChatPromotionCount,
      id: tutorialId,
      fields: 'WeChatPromotionCount'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 后端生成邀请卡
const getTutorialPromotionCard = (tutorialId, userId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getTutorialPromotionCard,
      tutorialId: tutorialId,
      userId: userId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//添加课程购买历史，只有免费课程可调用该接口, 用于记录同窗学员 
const addCoursePaidHistory = (tutorialId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.addCoursePaidHistory,
      tutorialId: tutorialId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

const paidCourseUser = (pageIndex,pageSize,tutorialId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.paidCourseUser,
      fields:'Id,Avatar,Nickname,PersonalStatus,Followed',
      pageIndex:pageIndex,
      pageSize:pageSize,
      tutorialId: tutorialId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//获取单个课程订单
const getCellCourseOrder = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getCellCourseOrder,
      fields: 'CreatedAt,Discount,PaymentChannel,Price,Payment,Id,Title,Buyer.Nickname',
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//******获取微信+邀币 Web 支付令牌
/**
 * 
 * @param {*} tutorialId 课程id
 * @param {*} openId 用户微信 openId
 * @param {*} couponId 优惠券Id
 */
const getWechatPayAddCoin = (tutorialId, openId, couponId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getWechatPayAddCoin,
      tutorialId: tutorialId,
      openId: openId,
      couponId: couponId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取微信 Web 支付令牌
/**
 * 
 * @param {*} tutorialId 课程id
 * @param {*} openId 用户微信 openId
 * @param {*} couponId 优惠券Id
 */
const getWechatPay = (tutorialId, openId, couponId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getWechatPay,
      tutorialId: tutorialId,
      openId: openId,
      couponId: couponId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//查找课程可用优惠卷列表,即查找指定课程可用的优惠卷列表, 订单支付时可调用该接口返回优惠卷列表,
const getCourseCoupon = (pageIndex, pageSize, tutorialId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getCourseCoupon,
      fields: 'Id,AmountLimit,Title,Cover,Value,CreatedAt,Description,ExpiresBegin,ExpiresEnd',
      pageIndex: pageIndex,
      pageSize: pageSize,
      tutorialId: tutorialId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//查找课程优惠卷列表,
const getCourseCouponList = (pageIndex, pageSize, expires) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getCourseCouponList,
      fields: 'Id,AmountLimit,Title,Cover,Value,CreatedAt,Description,ExpiresBegin,ExpiresEnd,Used,SpecificPhotographerId,SpecificTutorialId',
      pageIndex: pageIndex,
      pageSize: pageSize,
      expires: expires
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//刷新订单支付状态 该接口用于订单支付成功后刷新订单状态
const refreshCourseOrder = (orderId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.refreshCourseOrder,
      id: orderId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
/**
 * //帐户余额+邀币购买课程
 * @param {*} tutorialId 课程Id
 * @param {*} couponId 优惠券Id
 */
const coursePayForpalanceAddCoin = (tutorialId, couponId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.coursePayForpalanceAddCoin,
      tutorialId: tutorialId,
      couponId: couponId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
/**
 * //帐户余额购买课程
 * @param {*} tutorialId 课程Id
 * @param {*} couponId 优惠券Id
 */
const coursePayForpalance = (tutorialId, couponId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.coursePayForpalance,
      tutorialId: tutorialId,
      couponId: couponId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取单个课程信息 接口：获取单个课程
const LikeCourse = (tutorialId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.LikeCourse,
      tutorialId: tutorialId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//获取单个课程信息 接口：获取单个课程
const UnlikeCourse = (tutorialId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.UnlikeCourse,
      tutorialId: tutorialId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取单个课程信息 接口：获取单个课程
const getCourse = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getCourse,
      id: id,
      fields: 'Id,Cover,Title,SubTitle,Description,PriceZeroed,SpecialChannelEnabled,Price,OriginalPrice,Level,FavoritesCount,Items.VideoViewId,Items.Title,Items.Id,Items.Duration,Items.HasPreview,Items.Preview,Items.AliId,User.Avatar,User.PersonalStatus,User.Id,User.Nickname,User.Role,SalesCount,AverageRating,Tags.Id,Tags.Name,Paid,Liked,Favorited,WeChatPromotionCount,Points,PointsEnabled,PointsPrice'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//阿里云 获取单个课程播放 URL
const AliUrl = (ItemId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.AliUrl,
      ItemId:ItemId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// 查找课程评价列表
const searchCourseEvaluateList = (id, pageIndex, pageSize) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.searchCourseEvaluateList,
      fields: 'Content,CreatedAt,Rating,Buyer.Avatar,Buyer.Nickname,Buyer.Id,Buyer.Role',
      pageIndex: pageIndex,
      pageSize: pageSize,
      tutorialId: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//添加课程评价 只有存在对应用户和课程的销售历史时, 用户才能评价, 并且只允许评价一次.
/**
 * 
 * @param {*} tutorialId 课程 Id required
 * @param {*} rating   评分(1-5) required
 * @param {*} content 评价内容 (2-1000)
 */
const courseReview = (tutorialId, rating, content) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.courseReview,
      tutorialId: tutorialId,
      rating: rating,
      content: content
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 课程追评 接口：追加课程评价
/**
 * 
 * @param {*} tutorialId 课程 Id required
 * @param {*} rating   评分(1-5) required
 * @param {*} content 评价内容 (2-1000)
 */
const courseAddOnReview = (tutorialId, rating, content) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.courseAddOnReview,
      tutorialId: tutorialId,
      rating: rating,
      content: content
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//判断课程是否可评价
/**
 * 
 * @param {*} tutorialId  课程 Id required
 */
const checkCourseReview = (tutorialId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.checkCourseReview,
      tutorialId: tutorialId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//关闭未支付订单
/**
 * 
 * @param {*} id  订单id
 */
const closeCourseOrder = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.closeCourseOrder,
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//相关课程推荐的 接口：查找课程列表
/**
 * 
 * @param {*} pageIndex 页索引
 * @param {*} pageSize   页大小
 * @param {*} tagNames   查询指定标签名称列表中的数据
 * @param {*} specialChannelEnabled   是否支持其它渠道支付方案
 * @param {*} priceZeroed   定价是否为 0
 * @param {*} orderByRandom   是否启用随机排序, 默认为 false, 使用随机排序时, 其它排序方式将无效
 * @param {*} orderBySalesCount  按销量排序, Ascending - 升序, Descending - 降序
 * @param {*} orderByAverageRating 按平均分排序, Ascending - 升序, Descending - 降序
 * @param {*} userId 按课程发布用户 Id 查询
 */
//优选免费：1, 4, "", true, true, false
//销量排行：1, 8, "", false, false, false, false, Descending



//******新版课程获取接口
const getCourseListNew = (req) => {
  let data = {
    api: api.course.getCourseList,
    fields: 'Id,Cover,Title,SubTitle,Paid,ItemsCount,Liked,Durations,OriginalPrice,Price,PriceZeroed,SalesCount,Tags.Name,User.Avatar,User.Nickname,User.Id,User.Role,SpecialChannelEnabled,ReviewsCount,LikesCount,Points,PointsEnabled,PointsPrice',
    pageIndex: req.pageIndex,
    pageSize: req.pageSize,
    tagNames: req.tagNames,
    specialChannelEnabled: req.specialChannelEnabled,
    priceZeroed: req.priceZeroed,
    orderByRandom: req.orderByRandom,
    orderBySalesCount: req.orderBySalesCount,
    orderByAverageRating: req.orderByAverageRating,
    orderByLikesCount: req.orderByLikesCount,
    userId: req.userId,
    key: req.key,
    pointsEnabled: req.pointsEnabled
  }
  return new Promise((resolve, reject) => {
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//旧版课程获取接口
//销量排行：1, 8, "", false, false, false, false, Descending
const getCourseList = (pageIndex, pageSize, tagNames, specialChannelEnabled, priceZeroed, orderByRandom, orderBySalesCount, orderByAverageRating, userId, key) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getCourseList,
      fields: 'Id,Cover,ItemsCount,Paid,Title,SubTitle,Liked,Durations,OriginalPrice,Price,PriceZeroed,SalesCount,Tags.Name,User.Avatar,User.Nickname,User.Id,User.Role,SpecialChannelEnabled,ReviewsCount,LikesCount,Points,PointsEnabled,PointsPrice',
      pageIndex: pageIndex,
      pageSize: pageSize,
      tagNames: tagNames,
      specialChannelEnabled: specialChannelEnabled,
      priceZeroed: priceZeroed,
      orderByRandom: orderByRandom,
      orderBySalesCount: orderBySalesCount,
      orderByAverageRating: orderByAverageRating,
      userId: userId,
      key: key
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//点击收藏 收藏功能 接口：收藏课程
const storeCourse = (storeClassId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.storeCourse,
      tutorialId: storeClassId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取单个课程评价
const getCourseReview = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getCourseReview,
      fields: 'Content,CreatedAt,Rating,Id,PaidHistory.Title,PaidHistory.Cover,PaidHistory.TutorialId,Replies.Content,Replies.CreatedAt,Replies.Id,Replies.Replied,Replies.Type,Buyer.Id,Buyer.Avatar',
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//接口：查找收藏课程列表
const getStoreCourseList = (pageIndex, pageSize, fromUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getStoreCourseList,
      fields: "Id,Title,Cover,CreatedAt,SpecialChannelEnabled,PriceZeroed,Price,Paid,SalesCount,User.Avatar,User.Nickname,User.Id",
      pageIndex: pageIndex,
      pageSize: pageSize,
      fromUserId: fromUserId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}


//******查找课程类别列表
const getCourseType = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getCourseType,
      fields: "Id,TagIcon,TagName,Url",
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//******查找课程详细bannner
const getCourseTypeThis = (courseTypeId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getCourseTypeThis,
      id: courseTypeId,
      fields: "TagIcon,TagName,Url",
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//******查找课程类别下课程列表
const getCourseTypeCon = (pageIndex, pageSize, tagNames) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getCourseTypeCon,
      fields: 'Id,Title,Cover,Description,OriginalPrice,Price,FavoritesCount,Points,PointsEnabled,PointsPrice,SalesCount,PriceZeroed,SpecialChannelEnabled',
      pageIndex: pageIndex,
      pageSize: pageSize,
      tagNames: tagNames,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
  

//接口：查找购买历史列表
const getPaidCourseList = (pageIndex, pageSize, buyerId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.getPaidCourseList,
      fields: "Id,Title,Cover,TutorialId,SellerId,PriceZeroed,Reviewed,Price,Tutorial.SalesCount,Seller.Nickname,PaymentChannel,Payment,Reviewed,ReviewAddOned,Points",
      pageIndex: pageIndex,
      pageSize: pageSize,
      buyerId: buyerId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//点击收藏 取消收藏功能 接口：取消收藏课程
const UnstoreCourse = (storeClassId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.course.UnstoreCourse,
      tutorialId: storeClassId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//添加反馈意见
/**
 * 
 * @param {*} content 反馈内容 (2-1000)
 * @param {*} type 反馈类型
 * @param {*} contact 联系方式 (0-50)
 */
const addFeedback = (content, type, contact) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.addFeedback,
      content: content,
      type: type,
      contact: contact
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//检验手机号是否已经注册占用过了 接口：检查手机号可用性,返回结果为true为可用即未注册，false为不可用，已经注册
const checkPhoneNo = (userNo) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.checkPhoneNo,
      phoneNo: userNo
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//手机号验证手机验证码
const checkPhoneNoCode = (code, phoneNo, type) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.checkPhoneNoCode,
      code: code,
      phoneNo: phoneNo,
      type: type,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//兑换会员
const vipExchange = (redeemCode,userId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.vipExchange,
      redeemCode:redeemCode,
      userId:userId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//手机号换绑,需用户令牌，获取验证码
const changePhoneNo = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.changePhoneNo,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找资金历史列表
const getUserFundsList = (pageIndex, pageSize, increased) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.getUserFundsList,
      fields: 'Funds,Increased,CreatedAt,Description,State,Id,Type,UserId',
      pageIndex: pageIndex,
      pageSize: pageSize,
      increased: increased
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找提现列表
const getUserWithdrawList = (pageIndex, pageSize) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.getUserWithdrawList,
      fields: 'Id,CreatedAt,UpdatedAt,AcceptedAt,CompletedAt,Amount,Commission,Actual,Reason,State,UserId',
      pageIndex: pageIndex,
      pageSize: pageSize
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//申请提现
const userWithdraw = (amount) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.userWithdraw,
      amount: amount
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//接口：查找内购资金（苹果）历史列表
const getUserLapFundsList = (pageIndex, pageSize, increased) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.getUserLapFundsList,
      fields: 'Id,CreatedAt,Description,Funds,UpdatedAt,Increased,Type,State,UserId',
      pageIndex: pageIndex,
      pageSize: pageSize,
      increased: increased
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//手机号换绑验证,需用户令牌
const changePhoneNoVerify = (code) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.changePhoneNoVerify,
      code: code,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//手机号绑定
const bindPhoneNo = (phoneNo,TencentCaptchaValidate,RandStr) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.bindPhoneNo,
      phoneNo: phoneNo,
      TencentCaptchaValidate:TencentCaptchaValidate,
      RandStr:RandStr
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//手机号绑定验证
/**
 * 
 * @param {*} code 验证码
 * @param {*} phoneNo 新手机号
 */
const BindPhoneNoVerify = (code, phoneNo) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.BindPhoneNoVerify,
      code: code,
      phoneNo: phoneNo
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//已注册用户用手机号验证码登录 接口：验证码登录请求
const signInWithPhoneNo = (userNo,TencentCaptchaValidate,RandStr) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.signInWithPhoneNo,
      phoneNo: userNo,
      TencentCaptchaValidate:TencentCaptchaValidate,
      RandStr:RandStr
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//已注册用户用手机号验证码登录验证 接口：验证码登录验证
const signInWithPhoneNoVerify = (userCode, userNo) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.signInWithPhoneNoVerify,
      code: userCode,
      phoneNo: userNo
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找粉丝用户列表**
/**
 * 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} userId required 被关注用户的 Id
 */
const getFollowerList = (pageIndex, pageSize, userId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.getFollowerList,
      fields: 'Id,Avatar,Role,Followed,MutualFollowed,PersonalStatus,Nickname',
      pageIndex: pageIndex,
      pageSize: pageSize,
      userId: userId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找关注用户列表
/**
 * 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} userId  required 关注用户的 Id
 */
const getFollowingList = (pageIndex, pageSize, userId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.getFollowingList,
      fields: 'Id,Avatar,Role,Followed,MutualFollowed,Nickname,PersonalStatus',
      pageIndex: pageIndex,
      pageSize: pageSize,
      userId: userId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}



//退出登录 接口：退出登录
const SignOut = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.SignOut
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//注册时获取注册验证码 接口：手机号注册
const RegisterWithPhoneNo = (userNo, phonePrefix,TencentCaptchaValidate,RandStr) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.RegisterWithPhoneNo,
      phoneNo: userNo,
      phonePrefix: phonePrefix,
      TencentCaptchaValidate:TencentCaptchaValidate,
      RandStr:RandStr
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//注册验证 接口：手机号注册验证
const RegisterWithPhoneNoVerify = (codeNo, passWordNo, phoneNu) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.RegisterWithPhoneNoVerify,
      code: codeNo,
      passWord: passWordNo,
      phoneNo: phoneNu
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//登录 接口：密码登录
const loginPassword = (userpassWord, userlogin) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.loginPassword,
      passWord: userpassWord,
      userName: userlogin
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//微信登录 接口：微信登录，*****没有用这个接口，还有另一个微信登录的api*****
const logweChat = (logrefreshToken, logappId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.logweChat,
      refreshToken: logrefreshToken,
      appId: logappId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//登录时忘记密码 接口：手机号重置密码
const forgetPassWord = (forgetPhoneNo) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.forgetPassWord,
      phoneNo: forgetPhoneNo
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//登录时忘记密码在获取了找回密码的验证码后，表单验证 接口：手机号重置密码验证
const forgetPassWordVerify = (forgetCode, forgetPassWord, forgetPhoneNo) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.forgetPassWordVerify,
      code: forgetCode,
      passWord: forgetPassWord,
      phoneNo: forgetPhoneNo
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//登录后获取当前用户信息 接口：获取当前用户
const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.getCurrentUser,
      fields: 'Avatar,Role,Id,Nickname,PersonalStatus,PersonalBackground,Gender,BirthDate,Equipment,Account.PhoneNo,Account.LoginAt,Account.PhoneNo,Account.VipBeginAt,Account.VipEndAt,Account.PhotographerSelected,CityName,Statistic.FollowersCount,Statistic.FollowingsCount,Statistic.ArticleFavoritesCount,Statistic.TutorialFavoritesCount,Asset.Available,Asset.IapAvailable,Asset.Beneficiary'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//微信登录 接口：微信登录
const loginwechat = (wechatRefreshToken) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.loginwechat,
      refreshToken: wechatRefreshToken,
      appId: 'wx7954fc810c2c0a0b'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//微信绑定，需要在用户登录成功之后 接口：微信绑定
const bindingWechat = (WechatrefreshToken) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.bindingWechat,
      refreshToken: WechatrefreshToken,
      appId: 'wx7954fc810c2c0a0b'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//微信解绑 接口：微信解绑
const UnbindingWechat = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.UnbindingWechat
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//点击关注按钮，关注用户（需在登录的状态下） 接口：关注用户
const userFollow = (UserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.userFollow,
      userId: UserId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//点击关注按钮，取消关注用户（需在登录的状态下） 接口：取消关注用户
const UnuserFollow = (UserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.UnuserFollow,
      userId: UserId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// 接口：获取单个用户，//获取单个用户，在已经登录的情况下，输入userId，就可以查看当前登录的用户关注该userId的用户的情况了
const userGet = (TeacherId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.userGet,
      id: TeacherId,
      fields: 'Id,Nickname,Avatar,Role,Gender,Followed,PersonalStatus,PersonalBackground,Statistic.FollowingsCount,Statistic.FollowersCount,Statistic.ArticleListsCount,Statistic.SeriesListsCount,Statistic.TrendCount,Statistic.ArticleListsCount,Statistic.TutorialListsCount,Account.VipBeginAt,Account.VipEndAt'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找用户列表
const searchUserList = (key) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.searchUserList,
      fields: 'Id,Avatar,Followed,Role,MutualFollowed,Nickname,Statistic.FollowersCount',
      key: key
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// 七牛上传图片获取上传令牌 接口：存储 获取上传令牌
const getUptoken = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.common.getUptoken,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//刷新令牌  接口：刷新令牌
const refreshToken = (userExpiresToken) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.common.refreshToken,
      expiresToken: userExpiresToken
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//上传用户信息，修改用户头像和昵称 接口:修改个人信息
const updateInfoAvatarNikename = (userName, userAvatar) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.updateInfoAvatarNikename,
      nickname: userName,
      avatar: userAvatar
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//上传用户信息，修改用户详细信息 接口:修改个人信息
// const updateInfo = (personalBackground, userAvatar, userName, personalStatus, locationId, gender, birthDate, equipment) => {
//   return new Promise((resolve, reject) => {
//     let data = {
//       api: api.user.updateInfo,
//       personalBackground: personalBackground,
//       nickname: userName,
//       avatar: userAvatar,
//       personalStatus: personalStatus,
//       locationId: locationId,
//       gender: gender,
//       birthDate: birthDate,
//       equipment: equipment
//     }
//     axios.post(apiaddress, qs.stringify(data), {
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded'
//       }
//     }).then(res => {
//       resolve(res)
//     }).catch(res => {
//       reject(res.response)
//     })
//   })
// }
const updateInfo = (req) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.updateInfo,
      personalBackground: req.personalBackground,
      nickname: req.userName,
      avatar: req.userAvatar,
      personalStatus: req.personalStatus,
      locationId: req.locationId,
      gender: req.gender,
      birthDate: req.birthDate,
      equipment: req.equipment
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//绑定支付宝 接口:修改提现账户
const ChangeWithdrawAccount = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.ChangeWithdrawAccount,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//绑定支付宝验证 接口:修改提现账户验证
const ChangeWithdrawAccountVerify = (code, beneficiary) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.ChangeWithdrawAccountVerify,
      code: code,
      beneficiary: beneficiary
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取单个内购资金历史
const getCellLapFudsDetail = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.getCellLapFudsDetail,
      fields: 'CreatedAt,Description,State,Funds,Id,Increased,Type,UserId',
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取单个提现
const getCellWithdrawDetail = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.getCellWithdrawDetail,
      fields: 'Id,CreatedAt,Amount,Commission,Actual,CompletedAt,Reason,State,UserId',
      id: id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//检验昵称可用性 接口：检查昵称可用性
const CheckNickname = (usernickName) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.user.CheckNickname,
      nickName: usernickName
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取 Web 首页幻灯片 接口：获取 Web 首页幻灯片
const BannerImage = (Actions) => {
  return new Promise((resolve, reject) => {
    let data = {
      Actions:Actions,
      api: api.public.BannerImage
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//获取 Web 首页幻灯片 接口：获取 Web 首页幻灯片
const AdvertisementNew = (Actions) => {
  return new Promise((resolve, reject) => {
    let data = {
      Actions:Actions,
      api: api.public.AdvertisementNew
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}


//获取小程序首页幻灯片 接口：获取 小程序 首页幻灯片
const miniBannerImage = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.public.miniBannerImage
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取首页文章标签
const getHomeArticleTag = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.public.getHomeArticleTag
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取首页文章作者
const getHomeArticleUser = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.public.getHomeArticleUser
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//获取首页课程作者
const getHomeCourseUser = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.public.getHomeCourseUser
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//查找文章列表 接口：查找文章列表
/**
 * 
 * @param {*} pageIndex 页索引 required
 * @param {*} pageSize 页大小 required 
 * @param {*} advertisementTagNames 查询指定广告位标签名称列表中的数据
 * @param {*} tagNames 查询指定标签名称列表中的数据
 * @param {*} orderByViewsCount   按访问量排序, Ascending - 升序, Descending - 降序
 *  @param {*} userId 按文章发布用户 Id 查询
 */
const ArticleList = (pageIndex, pageSize, advertisementTagNames, tagNames, orderByViewsCount, userId, key) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.ArticleList,
      fields: 'Id,Title,Cover,ViewsCount,CommentsCount,CommentDisabled,LikesCount,Liked,CreatedAt,User.Avatar,User.Nickname,User.Id,Tags.Id,Tags.Name',
      pageIndex: pageIndex,
      pageSize: pageSize,
      advertisementTagNames: advertisementTagNames,
      tagNames: tagNames,
      orderByViewsCount: orderByViewsCount,
      userId: userId,
      key: key
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//文章详情，文章标题等信息 接口：获取单个文章,
/**
 * 
 * @param {*} id   需要获取数据的 Id required
 */
const getArticle = (id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getArticle,
      id: id,
      fields: 'Title,Cover,Liked,Favorited,Tags.Name,ViewsCount,CreatedAt,ViewUsersCount,CommentsCount,CommentDisabled,TipDisabled,FavoritesCount,LikesCount,TipDisabled,TipsCount,User.Avatar,User.Nickname,User.Id,User.PersonalStatus,User.Role',
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 获取文章的内容列表
/**
 * 
 * @param {*} pageIndex  页索引 required
 * @param {*} pageSize  页大小 required
 * @param {*} articleId  按文章 Id 查询 required
 */
const getArticleContentList = (pageIndex, pageSize, articleId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getArticleContentList,
      fields: 'ArticleId,Liked,CommentsCount,Content,Id,LikesCount,Type',
      pageIndex: pageIndex,
      pageSize: pageSize,
      articleId: articleId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//查找文章评论列表
/**
 * 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} articleId   按文章 Id 查询
 * @param {*} callFormat @ 解析格式, 见备注
 * @param {*} articleUserId   按文章用户 Id 查询
 */
const getArticleCommentList = (pageIndex, pageSize, articleId, callFormat, articleUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getArticleCommentList,
      fields: 'Id,Liked,ArticleId,ArticleContentId,Content,CreatedAt,LikesCount,User.Avatar,User.Role,User.Nickname,User.Id,ArticleContent.Type,ArticleContent.Content,ArticleContent.LikesCount,Article.Id,Article.Cover,Article.Title',
      pageIndex: pageIndex,
      pageSize: pageSize,
      articleId: articleId,
      callFormat: callFormat,
      articleUserId: articleUserId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找文章评论艾特列表
/**
 * 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} callFormat @ 解析格式, 见备注
 * @param {*} toUserId   按接收用户 Id 查询
 */
const getArticleCommentAtList = (pageIndex, pageSize, callFormat, toUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getArticleCommentAtList,
      fields: 'CreatedAt,Article.Id,Article.Cover,FromUser.Id,FromUser.Avatar,FromUser.Nickname,Comment.Content',
      pageIndex: pageIndex,
      pageSize: pageSize,
      callFormat: callFormat,
      toUserId: toUserId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//查找文章艾特列表
/**
 * 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} callFormat @ 解析格式, 见备注
 * @param {*} toUserId   按接收用户 Id 查询
 */
const getArticleAtList = (pageIndex, pageSize, toUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getArticleAtList,
      fields: 'CreatedAt,Article.Id,Article.Cover,Article.Title,FromUser.Id,FromUser.Avatar,FromUser.Nickname',
      pageIndex: pageIndex,
      pageSize: pageSize,
      toUserId: toUserId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// 喜欢-查找列表
/**
 * 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 */
const getMessageLike = (pageIndex, pageSize, ids, likeType, fromUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getMessageLike,
      fields: 'CreatedAt,Id,Picture,Content,LikeType,Data,Extension,FromUserId,FromUser.Id,FromUser.Avatar,FromUser.Nickname',
      pageIndex: pageIndex,
      pageSize: pageSize,
      ids: ids, // 需要获取的数据 Id 数组
      likeType: likeType, //@类型, 见备注
      fromUserId: fromUserId //发起人
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// 消息-评论-查找列表
/**
 * 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 */
const getMessageComment = (pageIndex, pageSize, ids, isRead, commentType, fromUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getMessageComment,
      fields: 'CreatedAt,Id,Picture,Title,Content,CommentType,Data,Extension,FromUserId,IsRead,FromUser.Id,FromUser.Avatar,FromUser.Nickname',
      pageIndex: pageIndex,
      pageSize: pageSize,
      ids: ids, // 需要获取的数据 Id 数组
      isRead: isRead, // 是否已读
      commentType: commentType, //@类型, 见备注
      fromUserId: fromUserId //发起人
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// 消息-评论-查找列表 将所有未读消息标记为已读
const MessageCommentReadAll = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.MessageCommentReadAll
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// @我的-查找列表
/**
 * 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 */
const getMessageCall = (pageIndex, pageSize, ids, isRead, callType, fromUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getMessageCall,
      fields: 'CreatedAt,Id,Picture,Content,CallType,Data,Extension,FromUserId,IsRead,FromUser.Id,FromUser.Avatar,FromUser.Nickname',
      pageIndex: pageIndex,
      pageSize: pageSize,
      ids: ids, // 需要获取的数据 Id 数组
      isRead: isRead, // 是否已读
      callType: callType, //@类型, 见备注
      fromUserId: fromUserId //发起人
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// @我的-查找列表 将所有未读消息标记为已读
const MessageCallReadAll = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.MessageCallReadAll
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// 查找文章打赏列表
/**
 * 
 * @param {*} pageIndex 页索引
 * @param {*} pageSize 页大小
 * @param {*} articleId  按文章 Id 查询
 */
const getArticleTipList = (pageIndex, pageSize, articleId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getArticleTipList,
      fields: 'BuyerId,Description,Amount,Buyer.Avatar,Buyer.Nickname',
      pageIndex: pageIndex,
      pageSize: pageSize,
      articleId: articleId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 查找通知列表
/**
 * 
 * @param {*} pageIndex 页索引
 * @param {*} pageSize 页大小
 * @param {*} articleId  需要获取的数据 Id 数组
 */
const getNoticeList = (pageIndex, pageSize, ids, isRead) => {
  // 1 50 "" undefined
  // 1 5 "" false
  // 1 50 "" false
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getNoticeList,
      fields: 'Id,CreatedAt,Title,Content,Action,Data,IsRead',
      pageIndex: pageIndex,
      pageSize: pageSize,
      ids: ids,
      isRead: isRead
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 标记已读
/**
 * 
 * @param {*} Id 数据 Id
 */
const readNotice = (Id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.readNotice,
      Id: Id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

// 标记全部已读
const readAllNotice = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.readAllNotice
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
// 查找点赞文章列表
/**
 * 
 * @param {*} pageIndex 页索引
 * @param {*} pageSize 页大小
 * @param {*} toUserId  按被点赞用户 Id 查询
 */
const getLikeList = (pageIndex, pageSize, toUserId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.article.getLikeList,
      fields: 'LikedUser.Avatar,LikedUser.Nickname,LikedUser.Id,CreatedAt,Id,Cover',
      pageIndex: pageIndex,
      pageSize: pageSize,
      toUserId: toUserId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}

//获取微信用户的头像和昵称 接口：YaoPai_API_v2 (前台)=>公共=>通用 Get 跨域  微信获取用户信息的地址方法：https://api.weixin.qq.com/sns/userinfo?access_token=${ACCESS_TOKEN}&openid=${OPENID}&lang=zh_CN
const getweichatUserinf = (ACCESS_TOKEN, OPENID) => {
  return new Promise((resolve, reject) => {
    // let url = `https://apiv2.dev.aiyaopai.com/cors/get?url=${encodeURIComponent(`https://api.weixin.qq.com/sns/userinfo?access_token=${ACCESS_TOKEN}&openid=${OPENID}&lang=zh_CN`)}`
    axios.get("https://apiv2.dev.aiyaopai.com/cors/get?url=" + encodeURIComponent("https://api.weixin.qq.com/sns/userinfo?access_token=" + ACCESS_TOKEN + "&openid=" + OPENID + "&lang=zh_CN")).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })

}

/**
 *领取手动发放优惠券 接口：TutorialCoupon.CollectionMmanual
 *@param: phoneNo 用户手机号
 *@param: ruleId 需要领取的优惠卷规则id
 */
const getCoupon = (phoneNo, ruleId) => {
  return new Promise((resolve, reject) => {
    axios.post(apiaddress, qs.stringify({
      api: 'TutorialCoupon.CollectionMmanual',
      phoneNo: phoneNo,
      ruleId: ruleId
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err.response)
    })
  })
}

/**
 * 查找课程优惠券列表
 * @param  ruleId 规则id
 * @param   fields 需要获取得字段列表
 */
const getCouponList = (ruleId) => {
  return new Promise((resolve, reject) => {
    axios.post(apiaddress, qs.stringify({
      api: 'TutorialCoupon.Search',
      pageIndex: 1,
      pageSize: 1,
      ruleId: ruleId,
      fields: 'CreatedAt'
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err.response)
    })
  })
}
/**
 * 获取单个课程优惠券
 * 
 */
const getTutorialCoupon = (id) => {
  return new Promise((resolve, reject) => {
    axios.post(apiaddress, qs.stringify({
      api: 'TutorialCoupon.Get',
      id: id,
      fields: 'CreatedAt'
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err.response)
    })
  })
}
/**
 * 获取单个课程优惠券规则
 * @param  ruleId 规则id
 * @param   fields 需要获取得字段列表
 */
const getCouponRule = (ruleId) => {
  return new Promise((resolve, reject) => {
    axios.post(apiaddress, qs.stringify({
      api: 'TutorialCouponRule.Get',
      id: ruleId,
      fields: 'Cover,Description,AmountLimit,Title,Value,ExpiresBegin,ExpiresDay,ExpiresEnd,Disabled,DisbursementLimit,DisbursementCount'
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err.response)
    })
  })
}
/**
 * 通过七牛获取图片的平均色 接口：<imageDownloadUri>?imageAve 
 */
const GetImageAvgColor = (imgUrl) => {
  return new Promise((resolve, reject) => {
    axios.get(`https://apiv2.dev.aiyaopai.com/cors/get?url=${encodeURIComponent(imgUrl+'?imageAve')}`).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}
/**
 * 获取wechat jsapi签名对象
 */
const jsapiSignature = () => {
  return new Promise((resolve, reject) => {
    axios
      .get('https://wechatauth.aiyaopai.com/auth/jsapisignature')
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        console.error(
          '===========> jsapiSignature 接口异常：',
          err.response.data.Message
        )
        reject(err)
      })
  })
}
/**
 * 获取地区文件
 */
const getAddressJson = () => {
  return new Promise((resolve, reject) => {
    axios.get(`https://apiv2.dev.aiyaopai.com/cors/get?url=${encodeURIComponent('https://storage-live-common.aiyaopai.com/location.json')}`).then(res => {
      resolve(res)
    }).catch(err => {
      console.error(err)
      reject(err)
    })
  })
}


// ******邀币相关接口
const getUserPoints = (Id) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.UserPoints.getUserPoints,
      Id:Id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
const getUserPointsHistory = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.UserPoints.getUserPointsHistory,
      fields: 'Id,CreatedAt,UpdatedAt,Points,Opration,UserId,DatadId'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
const getPointsMission = () => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.UserPoints.getPointsMission,
      fields: 'Id,Name,Description,MaxCount,Recycled,Enabled,Type,ButtonIcon,ButtonName,Points,CreatedAt,UpdatedAt,MissionProgress.MissionId,MissionProgress.UserId,MissionProgress.MaxCount,MissionProgress.CurrentCount,MissionProgress.Status'
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
const receivePoints = (MissionId) => {
  return new Promise((resolve, reject) => {
    let data = {
      api: api.UserPoints.receivePoints,
      MissionId: MissionId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      resolve(res)
    }).catch(res => {
      reject(res.response)
    })
  })
}
//查找动态位置列表
const TrendLocation=(pageIndex,pageSize,cityId,orderByPopularity,recommended)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.TrendLocation,
     fields:'Id,Name,Banner,Logo,Description,Address,Ratings,AverageRating,ReviewsCount,Recommended,TrendCount,JoinCount,CityName,CityId',
     pageIndex:pageIndex,
     pageSize:pageSize,
     cityId:cityId,
     orderByPopularity:orderByPopularity,
     recommended:recommended,
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}
//查找套系列表
const SeriesList=(pageIndex,pageSize,cityId,photographerId,photographyCategory)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.SeriesList,
     fields:'Name,Id,Favorited,MustShootReason,PhotographyCategory,FeatureTags,OriginalPicturesCount,RefinedPicturesCount,CityName,Price,Cover,CoverHeight,CoverWidth,Description,Style,SalesCount',
     pageIndex:pageIndex,
     pageSize:pageSize,
     cityId:cityId,
     photographerId:photographerId,
     photographyCategory:photographyCategory
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })
  })
}

//查找套系城市类目
const PhotographerCategory=(cityId)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.PhotographerCategory,
     cityId:cityId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}
//获取单个套系
const getSeriesDetail=(id)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.getSeriesDetail,
     fields:'Name,Id,Cover,OtherFeature,ResidualAmount,ShootEquipment,SamplesShow,ServiceDuration,Style,Delisting,PhotographerId,LocationCategoryId,PhotographyCategory,ShootCounts,FavoriteCount,SalesCount,Product,ShootScene,ServiceCities,ShootDescription,DepositEnabled,DepositAmount,Description,Favorited,AdvanceBookingDays,ClothesCount,DeliveryDays,MakeupsCount,OriginalPicturesCount,RefinedPicturesCount,ShootGroupsCount,Price,SalesCount,CoverHeight,CoverWidth,Photographer.Id,UserInfo.Id,UserInfo.Avatar,UserInfo.Nickname,UserInfo.PersonalStatus',
     id:id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}

//获取最新动态 Banner图
const TrendBanner=(cityId)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.TrendBanner,
     cityId:cityId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}

//查找动态列表-打卡地
const SearchLocation=(pageIndex,pageSize,locationId,cityId,orderByPopularity,orderByCreatedAt)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.SearchLocation,
     fields:'Id,Content,ContentType,Cover,Description,LikeCount,Liked,Address,User.Avatar,User.Id,User.Nickname',
     pageIndex:pageIndex,
     pageSize:pageSize,
     locationId:locationId,
     orderByPopularity:orderByPopularity,
     orderByCreatedAt:orderByCreatedAt,
     cityId:cityId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}
//获取首页热门城市
const HomeHotCityGet=()=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.HomeHotCityGet
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}

//获取单个动态位置
const getTrendLocation=(id)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.getTrendLocation,
     fields:'Id,Name,Banner,Logo,Description,Ratings,TrendCount,JoinCount,Address,AverageRating,ReviewsCount,Reviewed',
     id:id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}
 //用户下单
 const SeriresOrder=(seriesId,contactName,contactPhoneNo,contactPhonePrefix,code)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.SeriresOrder,
     seriesId:seriesId,
     contactName:contactName,
     contactPhoneNo:contactPhoneNo,
     contactPhonePrefix:contactPhonePrefix,
     code:code
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}

 //取消用户下单
 const SeriesUnFavorite=(seriesId)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.SeriesUnFavorite,
     seriesId:seriesId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}
//打卡地信息统计
const TrendLocationStatistics=(cityId)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.TrendLocationStatistics,
     cityId:cityId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}

//添加动态位置评价
const TrendLocationReview=(trendLocationId,rating)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.TrendLocationReview,
     trendLocationId:trendLocationId,
     rating:rating
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}
//获取摄影师类目
const LocationCategory=(photographyId)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.LocationCategory,
     photographyId:photographyId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}
 //用户下单
 const SeriesFavorite=(seriesId)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.SeriesFavorite,
     seriesId:seriesId
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}
//参与动态位置的用户列表
const TrendLocationJoinUser=(pageIndex,pageSize,Id)=>{
  return new Promise((resolve,reject)=>{
    let data={
     api:api.location.TrendLocationJoinUser,
     fields:'Avatar,Nickname,Id',
     pageIndex:pageIndex,
     pageSize:pageSize,
     Id:Id
    }
    axios.post(apiaddress, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res=>{
      resolve(res)
    }).catch(res=>{
      reject(res.response)
    })

  })
}



export default {
  // 课程
  course: {
    addCoursePaidHistory: addCoursePaidHistory, //添加课程购买历史
    paidCourseUser:paidCourseUser,
    getCourse: getCourse, //获取单个课程
    AliUrl:AliUrl,//获取单个课程播放 URL
    searchCourseEvaluateList: searchCourseEvaluateList, //查找课程评价列表
    getCourseList: getCourseList, //相关课程推荐的 接口：查找课程列表
    getCourseListNew: getCourseListNew, //
    storeCourse: storeCourse, //点击收藏 收藏功能 接口：收藏课程
    UnstoreCourse: UnstoreCourse, //点击收藏 取消收藏功能 接口：取消收藏课程
    getStoreCourseList: getStoreCourseList, //查找收藏课程列表
    getPaidCourseList: getPaidCourseList, //查找购买历史列表
    courseReview: courseReview, //添加课程评价
    checkCourseReview: checkCourseReview, //判断课程是否可评价
    courseAddOnReview: courseAddOnReview, //追加课程评价
    getWeChatPromotionCount: getWeChatPromotionCount,//******后端生成需要邀请人数 */
    getTutorialPromotionCard: getTutorialPromotionCard, //后端生成邀请卡
    getCourseCoupon: getCourseCoupon, //查找课程可用优惠卷列表
    coursePayForpalance: coursePayForpalance, //帐户余额购买课程
    coursePayForpalanceAddCoin: coursePayForpalanceAddCoin, //******账户余额+邀币购买课程
    refreshCourseOrder: refreshCourseOrder, //刷新订单支付状态
    getWechatPayAddCoin: getWechatPayAddCoin,//******获取微信+邀币Web支付令牌 */
    getWechatPay: getWechatPay, //获取微信 Web 支付令牌
    getCourseReview: getCourseReview, //获取单个课程评价
    getCourseCouponList: getCourseCouponList, //查找课程优惠卷列表,
    getCellCourseOrder: getCellCourseOrder, //获取单个课程订单
    closeCourseOrder: closeCourseOrder, //关闭未支付订单
    LikeCourse: LikeCourse, //课程点赞
    UnlikeCourse: UnlikeCourse, //取消课程点赞
    getCourseType: getCourseType,//******查找课程类别 */
    getCourseTypeThis: getCourseTypeThis,//******查找课程类别下详细banner */
    getCourseTypeCon: getCourseTypeCon//**********查找课程类别下的课程列表 */
  },
  // 文章
  article: {
    ArticleList: ArticleList, //接口：查找文章列表
    getArticle: getArticle, //接口：获取单个文章
    getArticleContentList: getArticleContentList, //获取文章的内容列表
    getArticleTipList: getArticleTipList, //查找文章打赏列表
    getArticleCommentList: getArticleCommentList, //查找文章评论列表
    getCollectArticleList: getCollectArticleList, //查找收藏文章列表
    articleLike: articleLike, //文章点赞
    articleUnlike: articleUnlike, //取消文章点赞
    articleCollect: articleCollect, //文章收藏
    articleUncollect: articleUncollect, //取消文章收藏
    articleCommentLike: articleCommentLike, //文章评论点赞 接口：点赞文章评论
    articleCommentUnlike: articleCommentUnlike, //取消文章评论点赞 接口：取消点赞文章评论
    articleContentLike: articleContentLike, //点赞文章内容 ,给文章的内容点赞，现在是文章的图片内容
    articleContentUnlike: articleContentUnlike, //取消点赞文章内容
    articleTipBalance: articleTipBalance, //文章打赏 余额打赏
    refreshArticleTip: refreshArticleTip, //刷新打赏支付状态  
    articleTipBywechatToken: articleTipBywechatToken, //获取微信 Web 支付令牌
    articleComment: articleComment, //添加文章评论
    getNoticeList: getNoticeList, //查找通知列表
    readNotice: readNotice, // 标记已读
    readAllNotice: readAllNotice, // 标记全部已读
    getLikeList: getLikeList, // 查找点赞文章列表
    getArticleCommentAtList: getArticleCommentAtList, //查找文章评论艾特列表
    getArticleAtList: getArticleAtList, //  查找文章艾特列表
    getMessageLike: getMessageLike, // 喜欢-查找列表
    getMessageComment: getMessageComment, // 消息-评论-查找列表
    MessageCommentReadAll: MessageCommentReadAll, // 消息-评论-查找列表 将所有未读消息标记为已读
    getMessageCall: getMessageCall, // @我的-查找列表
    MessageCallReadAll: MessageCallReadAll, // @我的-查找列表 将所有未读消息标记为已读
    getCellArticleTip: getCellArticleTip, //获取单个文章打赏
    articleAddView: articleAddView, //增加文章浏览量
    deleteArticleComment: deleteArticleComment,//**********删除文章评论 */
  },
  circle: {
    SearchRecommendId: SearchRecommendId, //推荐动态id
    ActivityVote:ActivityVote,
    TrendVoteRank:TrendVoteRank,
    SearchRecommendDetail: SearchRecommendDetail, //推荐或关注动态详情列表
    SearchTrend:SearchTrend,
    getRecommenViewTop: getRecommenViewTop,//推荐页动态列表置顶的动态
    getCellCircle: getCellCircle,
    TrendSearchUser:TrendSearchUser,
    TrendReview:TrendReview,
    GetTrendReview:GetTrendReview,
    LikeTrendList: LikeTrendList, //点赞动态列表 
    getUserTrendList: getUserTrendList, //查找动态列表-我发布的 
    LikeTrend: LikeTrend, //点赞动态 
    UnlikeTrend: UnlikeTrend, //取消点赞动态
    getTrendComment: getTrendComment, //查找动态评论列表
    likeTrendComment: likeTrendComment, //点赞动态评论
    unlikeTrendComment: unlikeTrendComment, //取消点赞动态评论
    addTrendComment: addTrendComment, //添加动态评论
    getCircleLikeList: getCircleLikeList, //查找点赞动态用户列表
    getFollowIdList: getFollowIdList, //查找动态列表-关注
    InsertTrend: InsertTrend, //发布动态
    InsertTrendTag: InsertTrendTag, //添加圈子
    UpdateTrendTag:UpdateTrendTag,//修改圈子
    JoinTrendTag: JoinTrendTag,
    SearchTrendTag: SearchTrendTag,
    MineTrend: MineTrend,
    UserFollowTrend: UserFollowTrend,
    getTrendList: getTrendList, //查找动态列表-圈子
    FollowTrendTag: FollowTrendTag, //关注圈子
    UnfollowTrendTag: UnfollowTrendTag, //取消关注圈子
    GetTrendTag: GetTrendTag, //获取单个圈子
    TrendTagJoinUser: TrendTagJoinUser, //参与圈子的用户列表
    GetCollectTrendList: GetCollectTrendList, //获取收藏动态列表
    GenerateCombinedCard: GenerateCombinedCard, //动态生成分享图
    CollectTrend: CollectTrend, //收藏动态
    UnCollectTrend: UnCollectTrend, //取消收藏动态
    deleteTrendComment: deleteTrendComment,//**********删除动态评论 */
    deleteTrend: deleteTrend//*********删除动态 */
  },
  location:{
    TrendLocation:TrendLocation,//查找动态位置列表
    SeriesList:SeriesList,//获取套系列表
    PhotographerCategory:PhotographerCategory,
    getSeriesDetail:getSeriesDetail,
    TrendBanner:TrendBanner,
    SearchLocation:SearchLocation,
    getTrendLocation:getTrendLocation,
    HomeHotCityGet:HomeHotCityGet,
    TrendLocationJoinUser:TrendLocationJoinUser,
    SeriresOrder:SeriresOrder,
    SeriesFavorite:SeriesFavorite,
    SeriesUnFavorite:SeriesUnFavorite,
    TrendLocationStatistics:TrendLocationStatistics,
    TrendLocationReview:TrendLocationReview,
    LocationCategory:LocationCategory
  },
  public: {
    AdvertisementNew:AdvertisementNew,
    BannerImage: BannerImage, //获取 Web 首页幻灯片 接口：获取 Web 首页幻灯片
    miniBannerImage: miniBannerImage,//获取小程序首页轮播
    getHomeArticleTag: getHomeArticleTag, //获取首页文章标签
    getHomeArticleUser: getHomeArticleUser, //获取首页文章作者
    getHomeCourseUser: getHomeCourseUser, //获取首页课程作者
  },
  //用户
  user: {
    changePhoneNo: changePhoneNo, //手机号换绑
    changePhoneNoVerify: changePhoneNoVerify, //手机号换绑验证,需用户令牌
    bindPhoneNo: bindPhoneNo, //手机号绑定
    BindPhoneNoVerify: BindPhoneNoVerify, //手机号绑定验证
    checkPhoneNo: checkPhoneNo, //检验手机号是否已经注册占用过了 接口：检查手机号可用性,返回结果为true为可用即未注册，false为不可用，已经注册
    signInWithPhoneNo: signInWithPhoneNo, //已注册用户用手机号验证码登录 接口：验证码登录请求
    signInWithPhoneNoVerify: signInWithPhoneNoVerify, //已注册用户用手机号验证码登录验证 接口：验证码登录验证
    RegisterWithPhoneNo: RegisterWithPhoneNo, //注册时获取注册验证码 接口：手机号注册
    RegisterWithPhoneNoVerify: RegisterWithPhoneNoVerify, //注册验证 接口：手机号注册验证
    loginPassword: loginPassword, //登录 接口：密码登录
    logweChat: logweChat, //微信登录 接口：微信登录
    loginwechat: loginwechat, //微信登录 接口：微信登录
    forgetPassWord: forgetPassWord, //登录时忘记密码 接口：手机号重置密码
    forgetPassWordVerify: forgetPassWordVerify, //登录时忘记密码在获取了找回密码的验证码后，表单验证 接口：手机号重置密码验证
    getCurrentUser: getCurrentUser, //登录后获取当前用户信息 接口：获取当前用户
    bindingWechat: bindingWechat, //微信绑定，需要在用户登录成功之后 接口：微信绑定
    UnbindingWechat: UnbindingWechat, //微信解绑 接口：微信解绑
    userFollow: userFollow, //点击关注按钮，关注用户（需在登录的状态下） 接口：关注用户
    UnuserFollow: UnuserFollow, //点击关注按钮，取消关注用户（需在登录的状态下） 接口：取消关注用户
    userGet: userGet, //接口：获取单个用户
    updateInfoAvatarNikename: updateInfoAvatarNikename, //上传用户信息，修改用户头像和昵称 接口:修改个人信息
    updateInfo: updateInfo, //上传用户信息，修改用户详细信息 接口:修改个人信息
    CheckNickname: CheckNickname, //检验昵称可用性 接口：检查昵称可用性
    SignOut: SignOut, //退出登录 接口：退出登录
    searchUserList: searchUserList, //查找用户列表
    getFollowerList: getFollowerList, //查找粉丝用户列表
    getFollowingList: getFollowingList, //查找关注用户列表
    addFeedback: addFeedback, //添加反馈意见
    ChangeWithdrawAccount: ChangeWithdrawAccount, // 修改提现账户
    ChangeWithdrawAccountVerify: ChangeWithdrawAccountVerify, //手机号修改提现账户验证
    getUserFundsList: getUserFundsList, //  查找资金历史列表
    getUserWithdrawList: getUserWithdrawList, //查找提现列表
    getUserLapFundsList: getUserLapFundsList, //  接口：查找内购资金（苹果）历史列表
    userWithdraw: userWithdraw, //申请提现
    getCellLapFudsDetail: getCellLapFudsDetail, //获取单个当前用户内购资金历史
    getCellWithdrawDetail: getCellWithdrawDetail, //获取单个提现
    checkPhoneNoCode: checkPhoneNoCode, // 该接口提供手机验证码统一验证功能, 适用于某些需要单独验证验证码的特定流程.
    vipExchange:vipExchange,
  },
  // 通用
  common: {
    getUptoken: getUptoken, //  七牛上传图片获取上传令牌 接口：存储 获取上传令牌
    refreshToken: refreshToken, //刷新令牌  接口：刷新令牌
    getweichatUserinf: getweichatUserinf, //获取微信用户信息
    jsapiSignature: jsapiSignature,
    getAddressJson: getAddressJson //获取地区文件
  },
  //优惠券
  getCoupon: getCoupon,
  getCouponList: getCouponList,
  getTutorialCoupon: getTutorialCoupon,
  getCouponRule: getCouponRule,
  GetImageAvgColor: GetImageAvgColor,

  //******邀币
  UserPoints:{
    getUserPoints: getUserPoints
    ,getUserPointsHistory: getUserPointsHistory
    ,getPointsMission: getPointsMission
    ,receivePoints: receivePoints
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js